import { css } from "@emotion/react";

export const headerStyle = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const navigationButtonStyle = css`
  border: none;
  font-size: 24px;
  cursor: pointer;

  width: 44px;
  height: 44px;
  opacity: 1;
  border-radius: 80px;
  background-color: #fff;
`;

export const headerContentStyle = css`
  display: flex;
  gap: 8px;
`;
